import React from 'react';
import Registros from '../components/Registros';

const RegistrosPage = () => {
  return (
    <div id='registrospage'>
      <Registros />
    </div>
  );
};

export default RegistrosPage;
